var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanBlowerFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Frame_1",
    "data-name": "Frame 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.999,
    height: 33,
    viewBox: "0 0 32.999 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811",
    transform: "translate(11.483 18.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M14.5,32.676a3.127,3.127,0,0,1-2.01-.6,1.929,1.929,0,0,1-.68-1.45,18.914,18.914,0,0,1,3-10.687c.51-.99,1.06-1.48,1.69-1.48,1.02,0,1.62,1.39,1.68,1.54l3,4.649a3.823,3.823,0,0,1-.03,4.529,6.633,6.633,0,0,1-.94,1.02,9.267,9.267,0,0,1-4.66,2.4,8.155,8.155,0,0,1-1.05.08Z",
    transform: "translate(-11.483 -18.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M16.5,18.77c.83,0,1.39,1.34,1.39,1.34l3.03,4.7a3.53,3.53,0,0,1,0,4.139,6.315,6.315,0,0,1-.92.99,9,9,0,0,1-4.5,2.329,6.275,6.275,0,0,1-1,.09,2.744,2.744,0,0,1-1.8-.53,1.651,1.651,0,0,1-.56-1.22,18.847,18.847,0,0,1,2.95-10.5c.5-1.01.99-1.34,1.41-1.34m0-.65c-.75,0-1.39.54-1.97,1.659A19.2,19.2,0,0,0,11.5,30.636a2.292,2.292,0,0,0,.8,1.689,3.393,3.393,0,0,0,2.21.68,6.437,6.437,0,0,0,1.11-.1,9.6,9.6,0,0,0,4.83-2.479,7.182,7.182,0,0,0,1-1.08,4.163,4.163,0,0,0,.04-4.859l-3.02-4.669c-.17-.35-.84-1.7-1.97-1.7Z",
    transform: "translate(-11.483 -18.12)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812",
    transform: "translate(10.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M16.5,14.556c-1.02,0-1.62-1.39-1.68-1.54l-3-4.649a3.823,3.823,0,0,1,.03-4.529,7.13,7.13,0,0,1,.94-1.02A9.267,9.267,0,0,1,17.45.42,6.671,6.671,0,0,1,18.5.33a3.078,3.078,0,0,1,2,.6,1.929,1.929,0,0,1,.68,1.45,18.914,18.914,0,0,1-3,10.687c-.5.99-1.05,1.49-1.68,1.49Z",
    transform: "translate(-10.785 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M18.51.64a2.744,2.744,0,0,1,1.8.53,1.651,1.651,0,0,1,.56,1.22,18.847,18.847,0,0,1-2.95,10.5c-.52,1.01-1.01,1.34-1.42,1.34-.83,0-1.39-1.34-1.39-1.34l-3.03-4.7a3.53,3.53,0,0,1,0-4.139,6.315,6.315,0,0,1,.92-.99A8.91,8.91,0,0,1,17.5.74a5.549,5.549,0,0,1,1.01-.1m0-.64A6.437,6.437,0,0,0,17.4.1a9.6,9.6,0,0,0-4.83,2.479,7.182,7.182,0,0,0-1,1.08,4.163,4.163,0,0,0-.04,4.859l3.02,4.669c.15.34.82,1.679,1.95,1.679.75,0,1.39-.54,1.97-1.659A19.2,19.2,0,0,0,21.5,2.349,2.292,2.292,0,0,0,20.7.66,3.443,3.443,0,0,0,18.51,0Z",
    transform: "translate(-10.785)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    transform: "translate(0 11.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M6.04,22.077a3.574,3.574,0,0,1-2.19-.72,6.2,6.2,0,0,1-1.02-.94A9.176,9.176,0,0,1,.42,15.769,3.748,3.748,0,0,1,.93,12.72a1.97,1.97,0,0,1,1.46-.68c.24-.01.47-.02.71-.02a19.129,19.129,0,0,1,10.02,3.009c1,.51,1.51,1.1,1.49,1.729-.04.99-1.39,1.57-1.55,1.63L8.4,21.377a4.615,4.615,0,0,1-2.36.7Z",
    transform: "translate(0 -11.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M3.09,12.34a19.108,19.108,0,0,1,9.84,2.949c3.04,1.56,0,2.8,0,2.8L8.21,21.107a4.3,4.3,0,0,1-2.17.65,3.208,3.208,0,0,1-1.98-.65,7.3,7.3,0,0,1-1-.91A8.851,8.851,0,0,1,.73,15.709a3.385,3.385,0,0,1,.44-2.789,1.652,1.652,0,0,1,1.22-.56c.24-.01.47-.02.7-.02m0-.64c-.24,0-.48.01-.72.02a2.294,2.294,0,0,0-1.69.8A4,4,0,0,0,.1,15.829a9.479,9.479,0,0,0,2.49,4.809,6.992,6.992,0,0,0,1.08.99,3.957,3.957,0,0,0,2.37.77,4.9,4.9,0,0,0,2.5-.74l4.69-3c.38-.16,1.64-.79,1.69-1.889.03-.76-.53-1.44-1.66-2.029A19.61,19.61,0,0,0,3.09,11.7Z",
    transform: "translate(0 -11.7)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814",
    transform: "translate(18.079 11.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M26.96,22.287a4.6,4.6,0,0,1-2.34-.69l-4.73-3.029c-.1-.04-1.45-.62-1.5-1.6-.03-.63.49-1.22,1.52-1.749A19.178,19.178,0,0,1,29.9,12.23c.23,0,.47.01.71.02a2,2,0,0,1,1.46.68,3.71,3.71,0,0,1,.51,3.049,9.254,9.254,0,0,1-2.41,4.649,6.572,6.572,0,0,1-1.05.96A3.6,3.6,0,0,1,26.96,22.287Z",
    transform: "translate(-18.079 -11.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M29.91,12.55c.23,0,.46,0,.69.02a1.652,1.652,0,0,1,1.22.56,3.311,3.311,0,0,1,.44,2.789,8.931,8.931,0,0,1-2.33,4.489,5.845,5.845,0,0,1-1,.91,3.208,3.208,0,0,1-1.98.65,4.181,4.181,0,0,1-2.17-.65L20.06,18.3s-3.04-1.24,0-2.8a19.21,19.21,0,0,1,9.85-2.949m0-.64h0a19.61,19.61,0,0,0-10.17,3.039c-1.14.59-1.69,1.27-1.66,2.029.05,1.1,1.31,1.729,1.69,1.889l4.67,2.989a4.946,4.946,0,0,0,2.52.75,3.988,3.988,0,0,0,2.37-.77,7.046,7.046,0,0,0,1.08-.99,9.518,9.518,0,0,0,2.49-4.809,4.05,4.05,0,0,0-.58-3.309,2.294,2.294,0,0,0-1.69-.8c-.24-.02-.48-.02-.72-.02Z",
    transform: "translate(-18.079 -11.91)",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815",
    transform: "translate(13.33 13.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M16.45,19.288a2.789,2.789,0,1,1,2.8-2.789A2.8,2.8,0,0,1,16.45,19.288Zm0-3.629a.84.84,0,1,0,.85.84A.86.86,0,0,0,16.45,15.659Z",
    transform: "translate(-13.33 -13.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M16.45,14.03A2.469,2.469,0,1,1,13.97,16.5a2.477,2.477,0,0,1,2.48-2.469m0,3.629a1.16,1.16,0,1,0-1.17-1.16,1.169,1.169,0,0,0,1.17,1.16m0-4.269A3.109,3.109,0,1,0,19.57,16.5a3.121,3.121,0,0,0-3.12-3.109Zm0,3.629a.516.516,0,0,1-.52-.52.523.523,0,0,1,.52-.52.52.52,0,1,1,0,1.04Z",
    transform: "translate(-13.33 -13.39)",
    fill: "#404041"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanBlowerFrame1);
export default __webpack_public_path__ + "static/media/fan_blower_frame1.54a8fefa4dfecad1a4962ab0379158dd.svg";
export { ForwardRef as ReactComponent };